import { PERMISSION_SCOPES } from '@clockwise/shared';
import { z } from 'zod';

export const PermissionEntrySchema = z.object({
  permission: z.string(),
  scope: z.enum(PERMISSION_SCOPES).optional(),
});
export type PermissionEntry = z.infer<typeof PermissionEntrySchema>;

export const SystemRoleSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  name: z.string(),
  description: z.string().nullable(),
  permissions: z.array(PermissionEntrySchema),
  active: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type SystemRole = z.infer<typeof SystemRoleSchema>;

const SystemRoleBody = z.object({
  name: z.string().min(1).max(120),
  description: z.string().nullable().optional(),
  permissions: z.array(PermissionEntrySchema).max(100).optional(),
  active: z.boolean().optional(),
});

export const CreateSystemRoleInput = SystemRoleBody;
export type CreateSystemRoleInput = z.infer<typeof CreateSystemRoleInput>;

export const PatchSystemRoleInput = SystemRoleBody.partial();
export type PatchSystemRoleInput = z.infer<typeof PatchSystemRoleInput>;

export interface ListSystemRolesQuery {
  q?: string;
  active?: boolean;
  sortField?: 'name' | 'createdAt' | 'updatedAt';
  sortDirection?: 'asc' | 'desc';
  limit?: number;
  offset?: number;
}
